export default __webpack_public_path__ + "media/images/series-a-news/bloomberg-linea-logo-c041c69d9aed734968ebe67e2b5870e2.png";